'use strict'

export let english_endStage={
  status: {
    green: "Completed within tolerances",
    yellow: "Issues or risks have surfaced. If not properly dealt with, the project's forecast can end up breaking the tolerances",
    red: "Broken tolerances for this stage. Exeption plan for the project might be needed."
  }
}



// WEBPACK FOOTER //
// ./views/components/labels/english_endStage.js